import type { FC } from "react";
import { useAtom, type PrimitiveAtom } from "jotai";
import { Textarea } from "@/components/podkit/forms/Textarea";

export const AutomationCommandStepEditor: FC<{ contentAtom: PrimitiveAtom<string> }> = ({ contentAtom }) => {
    const [value, setValue] = useAtom(contentAtom);
    return (
        <Textarea
            minHeight={120}
            maxHeight={400}
            className="text-base"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            placeholder="Enter a command"
        />
    );
};

export const AutomationPromptStepEditor: FC<{ contentAtom: PrimitiveAtom<string> }> = ({ contentAtom }) => {
    const [value, setValue] = useAtom(contentAtom);
    return (
        <Textarea
            minHeight={120}
            maxHeight={400}
            className="text-base"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            placeholder="Enter a prompt"
        />
    );
};
